module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', [(_vm.product.photo_link) ? _c('th', [_vm._v("Obraz")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Nazwa")]), _vm._v(" "), _c('th', [_vm._v("Cena")]), _vm._v(" "), _c('th', [_vm._v("Kategoria")]), _vm._v(" "), _c('th', [_vm._v("Brand")])])]), _vm._v(" "), _c('tbody', [_c('tr', [(_vm.product.photo_link) ? _c('td', [_c('div', {
    staticClass: "photo-preview"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.product.photo_link
    }
  })])]) : _vm._e(), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": _vm.product.url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.product.name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.product.price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.product.category_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.product.brand))])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "details"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5418111d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Product.vue
// module id = 1292
// module chunks = 2